export enum FoodUnit {
    GRAM = 'g',
    KILOGRAM = 'kg',
    MILLIGRAM = 'mg',
    LITER = 'l',
    MILLILITER = 'ml',
    CUP = 'cup',
    TABLESPOON = 'tbsp',
    TEASPOON = 'tsp',
    PIECE = 'piece',
    SLICE = 'slice',
    BOWL = 'bowl',
    PACKET = 'packet',
    BOTTLE = 'bottle',
    CAN = 'can',
    DOZEN = 'dozen',
    PINT = 'pt',
    QUART = 'qt',
    OUNCE = 'oz'
}

export const relatedUnitsMap: Record<FoodUnit, FoodUnit[]> = {
    // Weight
    [FoodUnit.KILOGRAM]: [FoodUnit.KILOGRAM, FoodUnit.GRAM, FoodUnit.MILLIGRAM, FoodUnit.OUNCE],
    [FoodUnit.GRAM]: [FoodUnit.GRAM, FoodUnit.MILLIGRAM, FoodUnit.OUNCE],
    [FoodUnit.MILLIGRAM]: [FoodUnit.MILLIGRAM],
    [FoodUnit.OUNCE]: [FoodUnit.OUNCE],

    // Volume
    [FoodUnit.LITER]: [FoodUnit.LITER, FoodUnit.MILLILITER, FoodUnit.CUP, FoodUnit.PINT, FoodUnit.QUART, FoodUnit.TABLESPOON, FoodUnit.TEASPOON],
    [FoodUnit.MILLILITER]: [FoodUnit.MILLILITER, FoodUnit.TEASPOON, FoodUnit.TABLESPOON],
    [FoodUnit.CUP]: [FoodUnit.CUP, FoodUnit.TABLESPOON, FoodUnit.TEASPOON],
    [FoodUnit.TABLESPOON]: [FoodUnit.TABLESPOON, FoodUnit.TEASPOON],
    [FoodUnit.TEASPOON]: [FoodUnit.TEASPOON],
    [FoodUnit.PINT]: [FoodUnit.PINT, FoodUnit.MILLILITER, FoodUnit.LITER],
    [FoodUnit.QUART]: [FoodUnit.QUART, FoodUnit.LITER, FoodUnit.MILLILITER],

    // Countable
    [FoodUnit.PIECE]: [FoodUnit.PIECE],
    [FoodUnit.SLICE]: [FoodUnit.SLICE],
    [FoodUnit.BOWL]: [FoodUnit.BOWL],
    [FoodUnit.PACKET]: [FoodUnit.PACKET],
    [FoodUnit.BOTTLE]: [FoodUnit.BOTTLE],
    [FoodUnit.CAN]: [FoodUnit.CAN],
    [FoodUnit.DOZEN]: [FoodUnit.DOZEN, FoodUnit.PIECE],
};

export enum DiscountType {
    PERCENT = "PERCENT",
    FIXED = "FIXED",
}
export enum TaxType {
    GST = "GST",
    VAT = "VAT"
}

export enum CartType {
    DINE_IN = "DINE_IN",
    TAKE_AWAY = "TAKE_AWAY"
}

export enum DashboardTabs {
    TAB_TAKE_AWAY = 'TAB_TAKE_AWAY',
    TAB_DELIVERY = 'TAB_DELIVERY',
    TAB_DINE_IN = 'TAB_DINE_IN',
    TAB_REFUND = 'TAB_REFUND',
    TAB_ORDER_TRACKING = 'TAB_ORDER_TRACKING'
}

export enum OrderTrackingTabs {
    TAB_TRACK_ORDER = 'TAB_TRACK_ORDER',
    TAB_ORDER_CANCELLATION = 'TAB_ORDER_CANCELLATION',
    TAB_ORDER_RECALL = 'TAB_ORDER_RECALL'
}

export enum RewardType {
    FIXED = 'FIXED',
    PERCENTAGE = 'PERCENTAGE',
    FREE = 'FREE',
}
export enum RewardStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum PaymentStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    REFUNDED = 'REFUNDED',
    PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    CANCELLED = 'CANCELLED',
}